import webHookMutations from "./mutations.js";
import webHookActions from "./actions.js";
import webHookGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: webHookMutations,
  actions: webHookActions,
  getters: webHookGetters,
};
